import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { nextStep, dropFiles } from '../redux/actions/actions';
import Dropzone from "react-dropzone";
import { ImageInfoDiv } from './constants/infoConstants';

const UploadImage = (props) => {
    const [showUserinfoDiv, setShowUserinfoDiv] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    const handleDrop = (files) => {        
        files.sort(function(imga, imgb){
            if(imga.path < imgb.path) { return -1; }
            if(imga.path > imgb.path) { return 1; }
            return 0;
        })
        props.dropFiles(files, "IMAGES");
        props.nextStep("upload files", props.prev_step);
    }

    useEffect(() => {
        if(props.setShowTools)
            props.setShowTools(false);
    }, [])

    return (
        <div>
        <h1 className='userHelpCircle' onClick={() => setShowUserinfoDiv(!showUserinfoDiv)}>?</h1>
            <div className="uploadImages">
                {props.prev_step === "new level" || props.prev_step === "exist images" ?
                    <div className="other_case_tool">
                        <a href="" onClick={(event)=>{
                            event.preventDefault();
                            props.nextStep("image library", "new level");
                        }}>
                            Choose images from library
                        </a>
                    </div> : ""}

                <Dropzone onDrop={handleDrop}>
                    {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps({ className: "dropzone" })}>
                            <h3>Drop photos here</h3>   
                            <h3>Or</h3>
                            <input {...getInputProps()} />
                            <button>Choose files</button>
                            {/* <p>Creating a multi level iFloorPlan</p>
                            <p>You can upload all your images for this property. Access them from the Image library</p>                        */}
                        </div>
                        
                    )}
                </Dropzone>
                
                {props.prev_step === "image library" ? 
                    (<button 
                        className="cancelUpload"
                        onClick={(event) => {
                            event.preventDefault();
                            props.nextStep("image library", '_')}}
                    >
                        Cancel
                    </button>) : 
                    (<div className='cancel'>
                        <br/>
                        <h3 style={{
                            fontSize: "3rem",
                            color: "#000",
                        }}>Or</h3>
                        <br/>
                        <div style={{
                            display: showMessage ? "flex" : "none",
                            fontWeight: "bold",
                            color: "#000",
                            justifyContent: "space-around",
                            maxWidth: "50rem",
                            margin: "0px auto 20px",
                        }}>
                            <p style={{
                                color: "#000",
                            }}>Please upload 1 still image for the splash screen</p>
                            <a style={{
                                color: "#1276eb",
                                fontSize: '1.3rem',
                            }}
                                onClick={(event) => {
                                    if(props.prev_step === "template"){
                                        event.preventDefault();
                                        props.nextStep("360 library upload", "template");
                                    } else {
                                        event.preventDefault();
                                        props.nextStep('360 library upload', "new level");
                                    }
                                }}
                            >I'll do it later &gt;</a>
                        </div>
                        <button className="cancel_btn" onClick={(event)=>{
                            setShowMessage(true);
                        }}>
                            {/* No thanks - Continue */}
                            Only upload panoramas &gt;
                        </button>
                    </div>
                    )}           
            </div>
            
            {showUserinfoDiv ? <ImageInfoDiv />: ''}
        </div>
    );
}

const putState = (state) => {
    return {
        step: state.step,
        prev_step: state.prev_step,
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        dropFiles: (files, title) => dispatch(dropFiles(files, title))
    }
}

export default connect(putState, putActions) (UploadImage);